<div class="vw-seite">
  <app-verwaltung-nav
    class="vw-seite__nav"
    [aktiv]="bereichId()"
    [firmenname]="store.firmenname()"
    [eingeladen]="store.eingeladen()"
    [rechnerOffline]="store.rechnerOffline()"
    (waehlen)="bereichWaehlen($event)"
  />
  <div class="vw-seite__inhalt">
    @let aktuell = bereich();
    @if (!aktuell.eigenerKopf) {
      <app-vw-kopf
        [titel]="aktuell.titel | translate"
        [untertitel]="aktuell.untertitel ? (aktuell.untertitel | translate) : ''"
      />
    }
    @if (aktuell.id === 'benutzer') {
      <app-verwaltung-benutzer />
    }
    @if (aktuell.id === 'ki') {
      <app-verwaltung-ki />
    }
    @if (aktuell.id === 'erscheinungsbild') {
      <app-erscheinungsbild />
    }
    @if (aktuell.id === 'projekte') {
      <app-verwaltung-projekte />
    }
    @if (aktuell.id === 'auswahllisten') {
      <app-vw-auswahllisten />
    }
    @if (aktuell.id === 'rechner') {
      <app-vw-rechner />
    }
  </div>
</div>

<app-confirm-dialog
  [visible]="rueckfrageOffen()"
  [title]="'settings.deactivateConfirm.title' | translate"
  [message]="'settings.deactivateConfirm.message' | translate"
  [confirmLabel]="'settings.deactivateConfirm.confirm' | translate"
  [cancelLabel]="'settings.deactivateConfirm.cancel' | translate"
  icon="warning"
  confirmColor="warn"
  (confirmed)="rueckfrageBeantworten(true)"
  (cancelled)="rueckfrageBeantworten(false)"
/>
